import React from 'react';
import SeniorAssociation2023 from 'views/SeniorAssociation2023';

const AccountGeneralPage = () => {
  return <SeniorAssociation2023 />;
};

export default AccountGeneralPage;
